/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_GivethInputs */



/**
* | output |
* | --- |
* | "The Rift giveth, the Rift taketh away." |
*
* @param {Error_Subtext_GivethInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_giveth = /** @type {((inputs?: Error_Subtext_GivethInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_GivethInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Rift gibt, der Rift nimmt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La Faille donne, la Faille reprend.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("裂隙给予，裂隙也收回。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("裂隙給予，裂隙也奪走。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("균열은 주기도 하고 가져가기도 합니다.")
	return /** @type {LocalizedString} */ ("The Rift giveth, the Rift taketh away.")
});